import VaultConfig from './config'
import { shouldPreserveDirectMobileFlowVaultData } from '../../components/utils/storage'
export default {
  clearVaultData(state) {
    localStorage.removeItem(VaultConfig.LOCAL_STATES.VAULT_LOCK)
    localStorage.removeItem(VaultConfig.LOCAL_STATES.VAULT_DATA)
    if (!shouldPreserveDirectMobileFlowVaultData()) {
      localStorage.removeItem(VaultConfig.LOCAL_STATES.VAULT_DATA_RAW)
    }
    localStorage.removeItem(VaultConfig.LOCAL_STATES.VAULT_KEY_DATA)
    localStorage.removeItem(VaultConfig.LOCAL_STATES.VAULT_KEY_DATA_RAW)
    localStorage.removeItem(VaultConfig.LOCAL_STATES.AUTH_SERVER_TOKEN)
    localStorage.removeItem(VaultConfig.LOCAL_STATES.VAULT_SALT)
    localStorage.removeItem(VaultConfig.LOCAL_STATES.VAULT_ID)
    localStorage.removeItem('vault.vaultPin')
    sessionStorage.removeItem('vault.vaultMnemonic')

    state.vaultPin = ''
    state.vaultMnemonic = ''
    state.vault = null
    state.vaultWallet = null
    state.vaultId = ''
    state.vaultSalt = ''
    state.authServerAuthToken = ''
  },

  setVaultMnemonic(state, payload) {
    state.vaultMnemonic = payload
    // Store in sessionStorage so it survives a page refresh for new users
    // who haven't completed PIN setup yet (vault.vaultData doesn't exist yet).
    // sessionStorage is cleared when the tab is closed.
    if (payload) {
      sessionStorage.setItem('vault.vaultMnemonic', payload)
    } else {
      sessionStorage.removeItem('vault.vaultMnemonic')
    }
  },

  setVaultWallet(state, payload) {
    state.vaultWallet = payload
  },

  setVault(state, payload) {
    state.vault = payload
  },

  setVaultId(state, payload) {
    state.vaultId = payload
    localStorage.setItem(VaultConfig.LOCAL_STATES.VAULT_ID, payload)
  },

  clearVaultPin() {
    localStorage.setItem(VaultConfig.LOCAL_STATES.VAULT_LOCK, false)
  },

  setVaultPin(state, payload) {
    state.vaultPin = payload
  },
  setVaultSalt(state, payload) {
    state.vaultSalt = payload
    localStorage.setItem(VaultConfig.LOCAL_STATES.VAULT_SALT, payload)
  },

  setVaultData(state, payload) {
    localStorage.setItem(VaultConfig.LOCAL_STATES.VAULT_DATA, payload)
  },

  setAuthServerAuthToken(state, payload) {
    state.authServerAuthToken = payload
    if (payload) {
      localStorage.setItem(VaultConfig.LOCAL_STATES.AUTH_SERVER_TOKEN, payload)
    } else {
      localStorage.removeItem(VaultConfig.LOCAL_STATES.AUTH_SERVER_TOKEN)
    }
  },

  updateVaultRawCredentials(state, payload) {
    let vaultRaw = localStorage.getItem(VaultConfig.LOCAL_STATES.VAULT_DATA_RAW)
    if (vaultRaw) {
      vaultRaw = JSON.parse(vaultRaw)
      if (!Array.isArray(vaultRaw.hypersign.credentials)) {
        vaultRaw.hypersign.credentials = []
      }
      vaultRaw.hypersign.credentials.push(...payload)
    }
    if (typeof vaultRaw === 'object') {
      vaultRaw = JSON.stringify(vaultRaw)
    }
    localStorage.setItem(VaultConfig.LOCAL_STATES.VAULT_DATA_RAW, vaultRaw)
  },

  setVaultRaw(state, payload) {
    let vaultRaw = localStorage.getItem(VaultConfig.LOCAL_STATES.VAULT_DATA_RAW)
    if (vaultRaw) {
      vaultRaw = JSON.parse(vaultRaw)
      if (vaultRaw.hypersign) {
        if (Array.isArray(vaultRaw.credentials) && typeof payload === 'object') {
          vaultRaw.credentials.push(JSON.parse(payload))
        }
      }
    } else {
      vaultRaw = payload
    }

    if (typeof vaultRaw === 'object') {
      vaultRaw = JSON.stringify(vaultRaw)
    }
    localStorage.setItem(VaultConfig.LOCAL_STATES.VAULT_DATA_RAW, vaultRaw)
  },

  setVaultLockStatus(state, payload) {
    localStorage.setItem(VaultConfig.LOCAL_STATES.VAULT_LOCK, payload)
  },
}
